import { useField } from 'formik'
import { useEffect } from 'react'
import ReactSelect, { components } from 'react-select'
import { useInfoProviderContext } from 'utils/providers/InfoProvider/InfoProviderContext'
import FieldError from '../FieldError/FieldError'

import styles from './Select.module.scss'

const Control = (props) => {
  return <components.Control id="currencySelector" className={styles.select} {...props} />
}

const Option = (props) => {
  const {
    data: { icon, label, name },
    selectProps: { optionId },
  } = props

  return (
    <components.Option className={styles.option} {...props}>
      <div className={styles.option} id={`${optionId}_${label.toLowerCase()}-option`}>
        <div className={styles.icon}>
          <img src={icon} alt="option" />
        </div>
        {label} ({name})
      </div>
    </components.Option>
  )
}

const MenuList = (props) => {
  return <components.MenuList {...props} className={styles.menu_list} />
}

const ValueContainer = (props) => {
  return <components.ValueContainer {...props} className={styles.value_container} />
}

const SingleValue = (props) => {
  const { data } = props
  const { icon, label, name } = data
  return (
    <components.SingleValue className={styles.single_value} {...props}>
      <div className={styles.option}>
        <div className={styles.icon}>
          <img src={icon} alt="single value" />
        </div>
        {label} ({name})
      </div>
    </components.SingleValue>
  )
}

interface ISelectProps {
  name: string
  options: any
  placeholder: string
  id?: string
  optionId?: string
  isLoading?: boolean
}

const Select = ({ name, options, placeholder, id, optionId, isLoading }: ISelectProps) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [field, meta, helpers] = useField(name)
  const { value } = field
  const onChange = (val) => {
    helpers.setValue(val)
  }

  const info = useInfoProviderContext()

  useEffect(() => {
    const geoCode = info?.code

    if (geoCode === undefined) return

    const found =
      options.find((option) => {
        return option.countries?.toUpperCase().split(',').includes(geoCode.toUpperCase())
      }) ||
      options.find((option) => {
        return option.label === `USD`
      })
    helpers.setValue(found)
  }, [options, info?.code])

  return (
    <div className={styles.wrapper}>
      <ReactSelect
        inputId={id || 'select-input'}
        // @ts-ignore
        optionId={optionId || 'select-option'}
        isLoading={isLoading}
        styles={{
          control: (base) => ({
            ...base,
            borderRadius: 10,
            outline: 'none',
            paddingLeft: 36,
            backgroundColor: '#233D69',
            boxShadow: `none`,
            border: 'none',
          }),
          placeholder: (base) => ({
            ...base,
            color: 'white',
          }),
          menu: (base) => ({
            ...base,
            backgroundColor: '#233D69',
            color: 'white',
          }),
          option: (base, { data, isDisabled, isFocused, isSelected }) => ({
            ...base,
            backgroundColor: isDisabled
              ? undefined
              : isSelected
              ? '#132c54'
              : isFocused
              ? '#2a4574'
              : undefined,
            ':active': {
              ...base[':active'],
              backgroundColor: !isDisabled ? (isSelected ? data.color : '#132c54') : undefined,
            },
          }),
        }}
        className={styles.react_select}
        value={value}
        components={{ SingleValue, Control, Option, ValueContainer, MenuList }}
        onChange={onChange}
        name={name}
        isSearchable={false}
        placeholder={placeholder}
        options={options}
      />
      <FieldError name={name} />
    </div>
  )
}

export default Select
